import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutDriverPtaQuickInfo } from "./autogen/AutogenLayoutDriverPtaQuickInfo";

export class DriverPtaQuickInfo extends AutogenLayoutDriverPtaQuickInfo {
  sourceDriverAfterExecution(event: DataSourceExecutionEvent) {
    if (this.sourceDriverInfo.activeRow?.get("contact.mobile_phone")) {
        this.textboxContactmobilePhone.visible = true;
    } else {
        this.textboxContactphone.visible = true;
    }
  }
}
